import { useState, useRef } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { Col } from 'react-bootstrap';

import FloatingButton from '../../components/FloatingButton/FloatingButton';
import { aprobador, solicitante, inspector } from '../../security/constantsRols';
import { checkRol } from '../../security';
import { useFilterPinned } from '../../hooks/usePinnedFilter';

import ResultGrilla from './ServiceRequestGrilla/ServiceRequestGrilla';
import FilterServiceRequest from './FilterServiceRequest/FilterServiceRequest';

import './ServiceRequest.scss';

const ServiceRequest = () => {
  const [showFilters, setShowFilters] = useState(false);
  const { isFilterPinned, setIsFilterPinned } = useFilterPinned();
  const fixedDrawerHeightRef = useRef(null);

  const contentCardClass = !isFilterPinned ? 'container-filter-resultGrilla' : 'inbox-height-calc';

  const onAnchor = () => {
    setIsFilterPinned(!isFilterPinned);
  };

  const hideModalFilters = () => {
    setShowFilters(false);
  };

  const history = useHistory();

  const showCreateFn = () =>
    history.push({
      pathname: '/createMultiple',
      previusPath: '/'
    });

  if (checkRol(aprobador) && !checkRol(solicitante)) {
    <Redirect to="/approver" />;
  }
  if (!checkRol(inspector) && history.location.pathname === '/inspector/service') {
    <Redirect to="/" />;
  }

  return (
    <div className="pas-container overflow-x-hidden">
      <div className={contentCardClass}>
        <FilterServiceRequest
          hideModal={hideModalFilters}
          isFilterPinned={isFilterPinned}
          onAnchor={onAnchor}
          ref={fixedDrawerHeightRef}
          show={showFilters}
          showAnchor
        />

        <Col
          className="container-title-table service-tabs scrolled-table"
          ref={fixedDrawerHeightRef}
          sm={9}
        >
          <ResultGrilla isFilterPinned={isFilterPinned} setShowFilters={setShowFilters} />
        </Col>
      </div>
      {checkRol(solicitante) && <FloatingButton onClick={showCreateFn} />}
    </div>
  );
};

export default ServiceRequest;
